/**
 * Cases & Entities Page Hints
 *
 * Contextual hints for the business portal cases list and entities pages.
 * Targets elements tagged with `data-astor-id` on cases and entities pages.
 */

import type { HintConfig } from './hint-config.types';

export const casesEntitiesHints: HintConfig[] = [
  {
    id: 'cases-data-table',
    targetAstorId: 'cases-data-table',
    title: 'hints.cases.dataTable.title',
    description: 'hints.cases.dataTable.description',
    portal: 'business',
    route: '/loans',
    showOnce: true,
    priority: 'high',
    variant: 'info',
    placement: 'top',
  },
  {
    id: 'entities-new-entity',
    targetAstorId: 'entities-new-entity-btn',
    title: 'hints.entities.newEntity.title',
    description: 'hints.entities.newEntity.description',
    portal: 'business',
    route: '/entities',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'entities-data-table',
    targetAstorId: 'entities-data-table',
    title: 'hints.entities.dataTable.title',
    description: 'hints.entities.dataTable.description',
    portal: 'business',
    route: '/entities',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'top',
  },
  {
    id: 'documents-container',
    targetAstorId: 'documents-container',
    title: 'hints.documents.container.title',
    description: 'hints.documents.container.description',
    portal: 'business',
    route: '/documents',
    showOnce: true,
    priority: 'medium',
    variant: 'help',
    placement: 'top',
  },
];
